import React from 'react'
import {
  ButtonWrapper,
  CardHead,
  CardTitle,
  ColoredCard,
  TransferOrder,
  TransferOrdersList
} from './styles'
import { CheckpointCardProps } from './types'
import { useTranslation } from 'react-i18n-lite'
import {
  useIsMobile,
  Text,
  LinkButton,
  Button
} from '@yes.technology/react-toolkit'
import TransferOrderCard from 'component/TransferOrderCard'
import SitemodelModal from 'component/SitemodelModal/SitemodelModal'
import { useIsOpen } from 'shared/hooks'

function CheckpointCard({
  checkpoint,
  status,
  transferOrders
}: CheckpointCardProps) {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const { isOpen, open, close } = useIsOpen(false)

  const { uuid_status: statusCode, address } = checkpoint

  return (
    <ColoredCard
      hierarchyCardLevel={2}
      heightClass='extraSmall'
      $backgroundColor={status?.complement as string}
      centerHeaderElement={
        <CardTitle>{`${statusCode} | ${status?.des}`}</CardTitle>
      }
      iconColor='#303032'
    >
      <>
        <Text variant={isMobile ? 'content-04' : 'content-03'}>
          {checkpoint.des}
        </Text>

        <ButtonWrapper>
          <Button onClick={open} variant='secondary'>
            {t('checkpoint-section.view')}
          </Button>
        </ButtonWrapper>

        <ButtonWrapper>
          <LinkButton
            style={{ marginTop: 8 }}
            href={`geo:${address?.[0]?.latitude}, ${address?.[0]?.longitude};`}
            variant='secondary'
          >
            {t('checkpoint-section.map-button')}
          </LinkButton>
        </ButtonWrapper>
      </>
      <TransferOrder spacingClass={isMobile ? 'small' : 'extraSmall'}>
        <CardHead $bgColor='#0056CC'>
          <CardTitle $color='#FFF'>
            {t('checkpoint-section.transfer-order')}
          </CardTitle>
        </CardHead>

        <TransferOrdersList>
          {transferOrders.map((transferOrder) => (
            <TransferOrderCard
              key={transferOrder.uuid}
              transferOrder={transferOrder}
            />
          ))}
        </TransferOrdersList>
      </TransferOrder>
      {isOpen && (
        <SitemodelModal
          targetSitemodel={window.objectDetailsSitemodelUuid}
          title={`${t('checkpoint-section.view')} | ${checkpoint.des}`}
          searchParams={{
            uuid_objectclass: window.uuidObjectclassCheckpoint,
            'object-uuid': checkpoint.uuid
          }}
          onClose={close}
        />
      )}
    </ColoredCard>
  )
}

export default CheckpointCard
